/* tslint:disable */
/* eslint-disable */
/**
 * Lightly API
 * Lightly.ai enables you to do self-supervised learning in an easy and intuitive way. The lightly.ai OpenAPI spec defines how one can interact with our REST API to unleash the full potential of lightly.ai
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: support@lightly.ai
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
// SRC: https://github.com/OpenAPITools/openapi-generator/blob/master/modules/openapi-generator/src/main/resources/typescript-fetch/modelEnumInterfaces.mustache
// synched 02.02.2023
import * as yup from 'yup';
import * as fastJSON from 'fast-json-stringify';
import { StringSchema } from 'fast-json-stringify';
/**
 *
 * @export
 * @enum {string}
 */
export enum UserType {
    FREE = 'FREE',
    PROFESSIONAL = 'PROFESSIONAL',
    ENTERPRISE = 'ENTERPRISE',
    ADMIN = 'ADMIN'
}
/* LIGHTLY CUSTOM START -> modelEnumInterfaces */
export const UserTypeValidatorShape = [
    'FREE',
    'PROFESSIONAL',
    'ENTERPRISE',
    'ADMIN'
];
export const UserTypeValidator = yup.mixed().oneOf(UserTypeValidatorShape);
export const UserTypeStringifyShapeProperties = {};
export const UserTypeStringifyShape: StringSchema = {
    title: 'UserType Stringifier',
    type: 'string'
};
export const UserTypeStringify = (typeof process === 'object' && String(process) === '[object process]') ?
    fastJSON.build(UserTypeStringifyShape)
    :
        () => { throw new Error('fast-json-stringify only works in nodejs'); };
/* LIGHTLY CUSTOM END */
export function UserTypeFromJSON(json: any): UserType {
    return UserTypeFromJSONTyped(json, false);
}
export function UserTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserType {
    return json as UserType;
}
export function UserTypeToJSON(value?: UserType | null): any {
    return value as any;
}
